export const CONTACT_EMAIL = "dreamriders.armenia@gmail.com";
